import { Helmet } from "react-helmet-async";

const SEO = ({
  title,
  description,
  keywords,
  focusKeyphrase,
  canonical,
  lang = "en",
  ogTitle,
  ogDescription,
  noIndex = false,
  siteName = "Sigedon Cataloger",
  siteUrl = "https://catalogarius.net",
}) => {
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const canonicalUrl = canonical ? `${siteUrl}${canonical}` : null;

  return (
    <Helmet>
      <html lang={lang} />
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {focusKeyphrase && <meta name="focus-keyphrase" content={focusKeyphrase} />}
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      {(ogDescription || description) && (
        <meta property="og:description" content={ogDescription || description} />
      )}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      {(ogDescription || description) && (
        <meta name="twitter:description" content={ogDescription || description} />
      )}
    </Helmet>
  );
};

export default SEO;